// This is just an example,
// so you can safely delete all default props below

import userEnTranslations from 'src/modules/user/Translations/EN';
import catalogEnTranslations from 'src/modules/catalog/Translations/EN';
import ambitusEnTranslations from 'src/modules/ambitus/Translations/EN';
import validationEnTranslations from 'src/modules/validation/Translations/EN';
import globalEnTranslations from 'src/modules/global/Translations/EN';
import schoolEnTranslations from 'src/modules/school/Translations/EN';
import midiEnTranslations from 'src/modules/midi/Translations/EN';
import masteriesEnTranslations from 'src/modules/masteries/Translations/EN';
import playerEnTranslations from 'src/modules/player/Translations/EN';
import transpositionEnTranslations from 'src/modules/transposition/Translations/EN';
import teacherEnTranslations from 'src/modules/teacher/Translations/EN';
import musicalComponentsEnTranslations from 'src/modules/musical-components/Translations/EN';
import playableTranslations from 'src/modules/playable/Translations/EN';
import playClassTranslations from 'src/modules/play-class/Translations/EN';
import onboardingEnTranslations from 'src/modules/onboarding/Translations/EN';

export default {
  failed: 'Action failed',
  success: 'Action was successful',
  ...userEnTranslations,
  ...catalogEnTranslations,
  ...ambitusEnTranslations,
  ...validationEnTranslations,
  ...globalEnTranslations,
  ...schoolEnTranslations,
  ...midiEnTranslations,
  ...masteriesEnTranslations,
  ...playerEnTranslations,
  ...transpositionEnTranslations,
  ...teacherEnTranslations,
  ...musicalComponentsEnTranslations,
  ...playableTranslations,
  ...playClassTranslations,
  ...onboardingEnTranslations,
  routes: {
    home: 'Home',
    catalog: 'Songs',
    catalogImport: 'Add my song',
    challenges: 'Challenges',
    profile: 'Profile',
    onboarding: 'Onboarding',
    subscribe: 'Subscribe',
    subscribeSuccess: 'Thank you for your support!',
    userCatalog: 'Current songs',
    userRevision: 'Content to review',
    exercise: 'Exercise',
    reading: 'Reading',
    course: 'Course',
    evaluation: 'Evaluation',
    lessons: 'Lessons',
    lesson: 'Lesson',
    skills: 'Skills',
    skill: 'Skill',
    videos: 'Videos',
    lyricsEditor: 'Lyrics Editor',
    handprintsAdmin: 'Handprints Admin',
    rhythmicsAdmin: 'Rhythmics Admin',
    tests: 'Tests',
    synthTest: 'Synth Test',
    testNotification: 'Test Notification',
    login: 'Sign in',
    signup: 'Create account',
    forgotPassword: 'Change your password',
    changePassword: 'New password',
    maintenance: 'Maintenance',
    update: 'Update',
    updateError: 'Update failed',
    store: 'App available on stores!',
    accountDeleted: 'Your account has been deleted.',
    offline: 'Internet connection problem',
    authentication: 'Authentication',
    progress: 'Your progress',
    ambitus: 'Voice range settings',
  }
};
